import React from 'react';
import { FieldValues, Control, Controller, UseControllerProps } from 'react-hook-form';
import cx from 'clsx';

import { Input } from '@/components';

import style from './index.module.scss';

const DefaultRules = {
  max: Number.MAX_SAFE_INTEGER,
};

type Props = {
  name: string;
  inputClassName?: string;
  control: Control<FieldValues, object>;
  disabled?: boolean;
  prefixStr?: string;
  suffixStr?: string;
  inputWidth?: number;
  rules?: UseControllerProps['rules'];
  placeholder?: string;
};

export const NumberInputField = ({
  name,
  control,
  disabled,
  inputClassName,
  prefixStr,
  suffixStr,
  inputWidth = 140,
  rules,
  placeholder,
}: Props) => {
  return (
    <div className={style.fieldValue}>
      {prefixStr ? <span className={style.prefixStyle}>{prefixStr}</span> : null}
      <Controller
        name={name}
        control={control}
        rules={rules || DefaultRules}
        render={({ field, fieldState }) => (
          <Input
            className={cx([style.fieldInput, inputClassName, !!fieldState.error && style.invalid])}
            style={{ width: inputWidth }}
            type="number"
            value={field.value}
            onChange={x => field.onChange(x)}
            disabled={disabled}
            placeholder={placeholder}
          />
        )}
      />
      {suffixStr ? <span className={style.suffixStyle}>{suffixStr}</span> : null}
    </div>
  );
};
